var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"button is-warning",on:{"click":function($event){$event.preventDefault();return _vm.onApproveClick($event)}}},[_vm._v("Approve")])}
var staticRenderFns = []

export { render, staticRenderFns }